import React from 'react';


class WSPhoto extends React.Component {
    render(){
        const {
            name="",
            image="",
            bgcolor="#000000",
            textcolor="#FFFFFF",
            isRound=false,
            id="",
            imageWidth="100px",
            imageHeight="100px",
            fontSize="14px"
        } = this.props;
        return <div className={`wsphoto-block ${isRound?'wsphoto-round':''}`} style={
            {
                background:`${bgcolor}`,
                color:`${textcolor}`,
                width:`${imageWidth}`,
                height:`${imageHeight}`
            }}>
                {
                    image !== "" && image !== null && image !== undefined?
                    <div style={{
                        backgroundImage:`url(https://s3.${process.env.REACT_APP_AWS_S3_REGION}.amazonaws.com/${process.env.REACT_APP_AWS_S3_BUCKET}/workspacedisplayphotos/${id}/${image})`
                    }}></div>:
                    <div style={{fontSize:fontSize}}>
                        {name !== ""?name.substr(0,1):""}
                    </div>
                }
                
            
        </div>
    }

}

export default WSPhoto;